module.exports = __webpack_public_path__ + "img/Windfish-CreateEvent.dc003123.jpg";